// extracted by mini-css-extract-plugin
module.exports = {"rotate":"HarvestKpNftRewards_rotate__O6x89"};